import { FC } from "react";
import { Grid } from "@mui/material";

import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { EthInput } from "@dzambalaorg/mui-inputs-mask";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { ModuleType, TokenType, IMysteryBoxSearchDto } from "@framework/types";

interface IMysteryboxSearchFormProps {
  initialValues: Partial<IMysteryBoxSearchDto>;
  embedded?: boolean;
}

export const MysteryBoxSearchForm: FC<IMysteryboxSearchFormProps> = props => {
  const { initialValues, embedded } = props;

  const { query = "", contractIds = [], minPrice = "", maxPrice = "" } = initialValues;
  const fixedValues = { query, minPrice, maxPrice, contractIds };

  return (
    <SearchWithFilters initialValues={fixedValues}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 6 }}>
          <EthInput name="minPrice" />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <EthInput name="maxPrice" />
        </Grid>
        {!embedded ? (
          <Grid size={{ xs: 12 }}>
            <EntityInput
              name="contractIds"
              controller="contracts"
              multiple
              fetchData={{
                contractType: [TokenType.ERC721],
                contractModule: [ModuleType.MYSTERY],
              }}
            />
          </Grid>
        ) : null}
      </Grid>
    </SearchWithFilters>
  );
};
